const CircleLoaderFillSvg = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="loader"
  >
    <rect x="3" y="3" width="26" height="26" rx="13" stroke="#F2F4F7" strokeWidth="6" />
    <path
      d="M28.9288 14.6411C29.2157 17.3714 28.631 20.1225 27.2583 22.5C25.8857 24.8775 23.7956 26.7595 21.2876 27.8761"
      stroke="#1369E9"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="spinner-bg-overlay"
    />
  </svg>
);
export default CircleLoaderFillSvg;
